import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersEmployeeConditionSurveysNewResponseType } from "~/domains";

const request =
  async (): Promise<ApiManagersEmployeeConditionSurveysNewResponseType> => {
    const response =
      await new ApiClient().get<ApiManagersEmployeeConditionSurveysNewResponseType>(
        "/api/managers/employee_condition_surveys/new",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersEmployeeConditionSurveysNew = ({
  config = {},
}: PropsType = {}): UseQueryResult<ApiManagersEmployeeConditionSurveysNewResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersEmployeeConditionSurveysNew"],
    queryFn: request,
  });
};
